<template>
  <a-card :bordered="false">
    <a-form class="table-operator" :form="form" layout="inline">
      <a-form-item label="字典类型">
        <a-select
          style="width:240px"
          :options="selectData"
          defaultValue="请选择"
          @change="selectChange"
        >
        </a-select>
      </a-form-item>
    </a-form>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleInsertItem"
        >新增下级</a-button
      >
      <a-button type="primary" icon="plus" @click="handleInsertType"
        >新增类型</a-button
      >
    </div>

    <a-table
      rowKey="id"
      :columns="columns"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template v-for="col in colData" :slot="col" slot-scope="data, record">
        <div :key="col">
          <a-input
            v-if="record.editable"
            :value="data"
            @change="e => handleChange(e.target.value, record.id, col)"
          ></a-input>
          <template v-else>
            {{ data }}
          </template>
        </div>
      </template>
      <template slot="serial" slot-scope="data, record, index">{{
        index + 1
      }}</template>
      <template slot="actions" slot-scope="data, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="save(record.id)">保存</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定取消吗?" @confirm="cancel(record.id)">
              <a>取消</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a :disabled="editingKey !== ''" @click="edit(record.id)">编辑</a>
            <a-divider type="vertical" />
            <a @click="handleDel(record.id)">删除</a>
          </span>
        </div>
      </template>
    </a-table>
    <DictionaryTypeModal ref="DictionaryTypeModal" @ok="ModalSuccess" />
    <DictionaryModal ref="DictionaryModal" @ok="ModalSuccess" />
  </a-card>
</template>

<script>
import {
  findByPid,
  findPage,
  update,
  updateDicStatus
} from "@/api/system/dictionary";
import DictionaryTypeModal from "./modules/DictionaryTypeModal";
import DictionaryModal from "./modules/DictionaryModal";
const colData = ["dictionaryValue", "dictionaryCode", "sortNum", "remark"];
const columns = [
  {
    title: "#",
    scopedSlots: { customRender: "serial" }
  },
  {
    title: "字典名称",
    dataIndex: "dictionaryValue",
    scopedSlots: { customRender: "dictionaryValue" }
  },
  {
    title: "字典值",
    dataIndex: "dictionaryCode",
    scopedSlots: { customRender: "dictionaryCode" }
  },
  {
    title: "排序",
    dataIndex: "sortNum",
    scopedSlots: { customRender: "sortNum" }
  },
  {
    title: "备注",
    dataIndex: "remark",
    scopedSlots: { customRender: "remark" }
  },
  {
    title: "状态",
    dataIndex: "status",
    customRender: text => (text == "A" ? "有效" : "无效")
  },
  {
    title: "操作",
    scopedSlots: { customRender: "actions" }
  }
];

export default {
  components: {
    DictionaryModal,
    DictionaryTypeModal
  },
  data() {
    return {
      //search form
      form: this.$form.createForm(this),
      pid: 0,
      selectData: [],
      // table data
      colData,
      columns,
      data: [],
      pagination: {},
      loading: false,
      editingKey: ""
    };
  },
  created() {
    this.InitSelect({ pid: 0 });
    this.InitData({ pid: 0 });
  },
  methods: {
    InitSelect(params = {}) {
      new Promise((resolve, reject) => {
        findByPid({ ...params })
          .then(res => {
            this.selectData = res.result.map(item => {
              return { label: item.dictionaryValue, value: item.id };
            });
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    selectChange(e) {
      this.pid = e;
      this.InitData({ pid: e });
    },
    // 翻页器逻辑
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;

      this.InitData({
        rows: pagination.pageSize, //每页显示条数
        page: pagination.current, //页数
        sidx: sorter.field, //排序字段
        sord: sorter.order, //升降序
        ...filters
      });
    },
    // 加载table数据
    InitData(params = {}) {
      this.loading = true;
      findPage({ ...params }).then(res => {
        // console.log(res);
        const pagination = { ...this.pagination };
        pagination.total = res.records;
        this.loading = false;
        this.data = res.rows;
        this.pagination = pagination;
        this.cacheData = this.data.map(item => ({ ...item }));
      });
    },
    handleInsertItem() {
      this.$refs.DictionaryModal.showModal(this.pid);
    },
    handleInsertType() {
      this.$refs.DictionaryTypeModal.showModal();
    },
    ModalSuccess(msg) {
      this.$notification.success({
        message: msg
      });
      this.InitSelect({ pid: 0 });
      this.InitData({ pid: this.pid });
    },
    handleChange(value, id, column) {
      const newData = [...this.data];
      const target = newData.filter(item => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(id) {
      console.log(id);
      const newData = [...this.data];
      const target = newData.filter(item => id === item.id)[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    save(id) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => id === item.id)[0];
      const targetCache = newCacheData.filter(item => id === item.id)[0];
      if (target && targetCache) {
        this.loading = true;
        update({ ...target }).then(res => {
          if (res.resultCode === 1) {
            this.$notification.success({
              message: res.message
            });
            delete target.editable;
            this.data = newData;
            Object.assign(targetCache, target);
            this.cacheData = newCacheData;
          } else {
            this.$notification.error({
              message: res.message
            });
            this.cancel(id);
          }
          this.loading = false;
        });
      }
      this.editingKey = "";
    },
    cancel(id) {
      const newData = [...this.data];
      const target = newData.filter(item => id === item.id)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        delete target.editable;
        this.data = newData;
      }
    },
    // 软删除
    handleDel(id) {
      let that = this;
      let params = {
        dicIdStrs: id,
        status: "D"
      };
      this.$confirm({
        title: "提示",
        content: "是否确认删除该数据?",
        onOk() {
          updateDicStatus({ ...params })
            .then(res => {
              if (res.resultCode === 1) {
                that.$notification.success({
                  message: res.message
                });
              } else {
                that.$notification.error({
                  message: res.message
                });
              }
            })
            .finally(() => {
              that.InitData();
            });
        }
      });
    }
  }
};
</script>

<style></style>
